<template>
  <div class="app">
    <div class="background"></div>
    <LoadingApp v-if="isLoading" />
    <main v-else style="height: 100%; width: 100%; display: flex; flex-direction: column;">
      <MessagePopup />
      <AlertPopup />
      <router-view v-slot="{ Component }">
        <transition>
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script>
import HeadBar from "./components/HeadBar.vue";
import LoadingApp from "./components/LoadingApp.vue";
import MessagePopup from "./components/PopupComponents/MessagePopup.vue";
import AlertPopup from "./components/PopupComponents/AlertPopup.vue";
import { mapGetters } from "vuex";
import * as NAMESPACE_STORE from "./vuexStore/namespaceStore.js";

export default {
  name: 'App',
  components: {
    HeadBar,
    LoadingApp,
    MessagePopup,
    AlertPopup
  },
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters(NAMESPACE_STORE.USER, {
      isLoggedIn: "isLoggedIn"
    })
  },
  mounted() {
    // Masquer le chargement une fois que l'authentification est vérifiée
    this.$nextTick(() => {
      setTimeout(() => {
        this.isLoading = false;
      }, 500); // Délai minimum pour éviter le flash
    });
  },
  methods: {
  },
  watch: {
  },
}
</script>

<style>
.app {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  height: 100%;
  background: radial-gradient(circle at 25% 25%, #1e3a8a 0%, #111827 40%),
            radial-gradient(circle at 75% 75%, #7c3aed 0%, #111827 40%),
            radial-gradient(circle at 50% 50%, #1e40af 0%, #111827 60%),
            linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

main {
  flex: 1;
}

.animation-wow-top {
    animation: wow-top .5s ease-in-out;
}

.animation-wow-bottom {
    animation: wow-bottom .5s ease-in-out;
}

.animation-wow-left {
    animation: wow-left .5s ease-in-out;
}

.animation-wow-right {
    animation: wow-right .5s ease-in-out;
}

.animation-opacity {
    animation: opacity .5s ease-in-out;
}

.animation-zoom-in {
    animation: zoom-in .5s ease-in-out;
}

.animation-zoom-out {
    animation: zoom-out .5s ease-in-out;
}

@keyframes wow-top {
    0% {
        transform: translateY(-100px);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes wow-bottom {
    0% {
        transform: translateY(100px);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes wow-left {
    from {  
        transform: translateX(-100px);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes wow-right {
    from {
        transform: translateX(100px);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes opacity {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes zoom-in {
    from {
        transform: scale(1);
    }
    to {
        transform: scale(1.5);
    }
}

@keyframes zoom-out {
    from {
        transform: scale(1);
    }
    to {
        transform: scale(0.5);
    }
}
</style>
